import { useState } from "react";
import { usePost } from "./API";
import { ClickableButton } from "./Components/Button";
import { toast } from 'react-toastify';
import { BUTTON_CLASS } from "./Util";

export default function AccountingPage() {
    const sendTestEmail = usePost("/accounting/email_reconciliation_reports");
    const [sending, setSending] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const doSendEmail = async () => {
        setError(null);
        setSending(true);
        try {
            const res = await sendTestEmail({});
            if (res.error) {
                setError(res.error);
            } else {
                toast.success('Email sent');
            }
        } catch (e) {
            setError('Email failed to send');
        } finally {
            setSending(false);
        }
    };

    return <>
        <hr/>
        <h2>Monthly Reconciliation</h2>   
        <h4>Email Latest Available Report</h4>
        <ClickableButton color="indigo" extraClasses={BUTTON_CLASS} onClick={doSendEmail}>{sending ? 'Sending...' : 'Send Test Email'}</ClickableButton>
        {error ? <p className="text-red-500 mt-2">{error}</p> : null}
    </>
}
